class faqTabComponent extends HTMLElement {
    constructor() {
      super();
    this.subMenuBtns = this.querySelectorAll('.button--faq-navigation');
    
    theme.initWhenVisible({
      element: this,
      callback: this.init.bind(this),
      threshold: 200
    });
    }

    init() {
        this.subMenuBtns.forEach(btn=> btn.addEventListener('click', (e) => this.onClick(e)))
        this.activeTab = this.querySelector(".faq__tab[open]")
        this.activeNavigation =  this.querySelector(".button--faq-navigation[open]")
      }
    
    onClick(e) {
        e.preventDefault();
        this.newTabIndex= e.target?.dataset?.tabIndex;

        if(this.newTabIndex == undefined){return}
        this.newActiveTab = this.querySelector(`#tab-index-${this.newTabIndex}`)
        this.newActiveNavigation = document.querySelector(`.button--faq-navigation[data-tab-index="${this.newTabIndex}"]`)
        
        if(this.activeTab != this.newActiveTab)
        {
            this.close()
            this.open()   
        }
    }
    close(){ 
        if(this.activeTab == undefined || this.activeNavigation == undefined )return
        this.activeTab.removeAttribute("open");
        this.activeNavigation.removeAttribute("open");
        }
    open(){
        if(this.newActiveTab == undefined || this.newActiveNavigation == undefined )return
        this.newActiveTab.setAttribute("open","");
        this.newActiveNavigation.setAttribute("open","");
        // set new to the current values
        this.activeTab = this.newActiveTab
        this.activeNavigation = this.newActiveNavigation
    }
    
}

customElements.define('faq-tab-component', faqTabComponent);